import { Contact as ContactModel, FormModal } from 'models';

import ContactUsPerson from './ContactUsPerson';

export type SinglePersonPageProps = {
  person: Omit<ContactModel['elements'], 'key'> | null;
  form: FormModal | null;
};

const SinglePersonPage = ({ person, form }: SinglePersonPageProps) => {
  if (!person) {
    return <></>;
  }
  return <ContactUsPerson person={person} form={form} />;
};

export default SinglePersonPage;
